import { createFileRoute, Navigate } from '@tanstack/react-router';

import { useSettingsGates } from '@apps/web/features/settings';

export const Route = createFileRoute('/_app/settings/phone-try')({
    component: PhoneTrySettingsPage,
});

// The Try-it page was hidden because its "Place a test call" flow was never
// built; the route remains as a redirect for old links.
function PhoneTrySettingsPage() {
    const { isLoading } = useSettingsGates();

    if (isLoading) {
        return null;
    }

    return <Navigate to="/settings/phone" replace={true} />;
}
